import React from 'react';
import FinalForm from '@/Framework/UI/Organisms/FinalForm';
import FinsightModal from '@/finsight/ui/common/components/FinsightModal';
import { useRequestServiceModalContext } from '@/finsight/application/RequestServiceModalContext';
import { IRequestServiceData } from './IRequestServiceData';
import RequestServiceFields from './RequestServiceFields';
import validator from './validator';

const RequestServiceModal = () => {
  const { isOpen, titleModal, isFetching, closeModal, onSubmit } = useRequestServiceModalContext();

  return (
    <FinsightModal
      hideOnOverlayClicked
      isSuccessOverlay={ false }
      modalTitle={ titleModal }
      isFetching={ isFetching }
      isVisible={ isOpen }
      dataTest="requestServiceModal"
      onCloseClicked={ closeModal }
    >
      <FinalForm<IRequestServiceData, Partial<IRequestServiceData>>
        name="requestServiceForm"
        dataTest="requestServiceForm"
        render={ () => <RequestServiceFields /> }
        validate={ validator }
        onSubmit={ onSubmit }
      />
    </FinsightModal>
  );
};

export default RequestServiceModal;
